<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.costs')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <div id="chart"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Resume",
  data() {
    return {
      type: "line",
      chart: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.render()
      setTimeout(async () => {
        let res = await this.chart.dataURI()
        this.$emit('png', {chart: 'costs', png: res})
      }, 1000)
    },
    render() {
      let categories = this.categories()
      let series = this.series()
      if (this.chart) {
        this.chart.updateOptions({
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type
          }
        }, true);
      } else {
        this.chart = new ApexCharts(document.querySelector("#chart"), {
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type,
            height: 600,
            width: 1200,
            animations: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false,
          }
        });
        this.chart.render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index + 1));
      }
      return categories;
    },
    series() {
      let series = [];
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        let tempData = []
        for (let index = 0; index < this.week; index++) {
          let stock = company.data.cost.stock[index] ? company.data.cost.stock[index] : 0
          let remains = company.data.cost.remains[index] ? company.data.cost.remains[index] : 0
          tempData.push(stock + remains)
        }
        series.push({
          name: company.name,
          data: tempData
        });
      });
      return series;
    },
    async changeType () {
      await this.chart.destroy()
      this.chart = null
      if (this.type == 'line') {
        this.type = 'bar'
      } else {
        this.type = 'line'
      }
      this.render()
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        if (company.data.cost.stock.length > max) {
          max = company.data.cost.stock.length;
        }
        if (company.data.cost.remains.length > max) {
          max = company.data.cost.remains.length;
        }
      });
      return max;
    }
  }
};
</script>
